export const Constants = {
  AppleAppStoreAppUrl: 'https://apps.apple.com/au/app/tabtouch-racing-sports-bet/id472906558',
  BetStopURL: 'https://www.betstop.gov.au/',
  GamblingHelpOnlineURL: 'https://gamblinghelponline.org.au/',
  GamblingHelpPhoneNumber: '1800 858 858',
  GooglePlayStoreAppUrl: 'https://play.google.com/store/apps/details?id=com.rwwa.android.tabtouch',
  PrivacyPolicy: 'https://www.rwwa.com.au/privacy-policy/',
  ResponsibleWageringURL: 'https://www.tabtouch.mobi/Content/landing/responsible-wagering/',
  TABtouchTermsAndConditions: 'https://help.tabtouch.com.au/knowledge-base/terms-conditions/',
  TermsAndConditions: 'https://www.rwwa.com.au/terms---conditions',
} as const
